(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cellular-longevity-complex"] && !Shopify.designMode) return;
  try {
    
(function () {
  function connectCellularSection(root) {
    if (root.dataset.cellularSectionReady === 'true') return;
    root.dataset.cellularSectionReady = 'true';

    var h = root.querySelector('[id^="clchead-"]');
    if (h) {
      var last = window.pageYOffset;
      function updateHeader() {
        var y = window.pageYOffset;
        if (y < 40) {
          h.classList.remove('solid');
          h.classList.remove('hidden');
        } else if (y < last) {
          h.classList.add('solid');
          h.classList.remove('hidden');
        } else {
          h.classList.add('hidden');
          h.classList.remove('open');
        }
        last = y;
      }
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();

      var b = root.querySelector('[id^="clcburger-"]');
      if (b) {
        b.addEventListener('click', function (event) {
          event.stopPropagation();
          h.classList.toggle('open');
        });
        document.addEventListener('click', function () {
          h.classList.remove('open');
        });
      }
    }

    var pm = root.querySelector('[id^="clcheromedia-"]');
    if (pm) {
      window.addEventListener('scroll', function () {
        var rect = pm.getBoundingClientRect();
        var offset = (window.innerHeight / 2 - (rect.top + rect.height / 2)) * 0.06;
        pm.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      }, { passive: true });
    }

    var track = root.querySelector('[id^="clctrack-"]');
    if (track) {
      root.querySelectorAll('.clc-arrow').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var first = track.querySelector('.clc-pub');
          var step = first ? first.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({
            left: step * parseInt(arrow.dataset.dir, 10),
            behavior: 'smooth'
          });
        });
      });
    }
  }

  function connectBioAgePreorderButtons() {
    var buttons = document.querySelectorAll(
      'a[href$="#BioAgePreorder"]'
    );

    buttons.forEach(function (button) {
      if (button.dataset.klaviyoTriggerReady === 'true') {
        return;
      }

      button.dataset.klaviyoTriggerReady = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        window._klOnsite = window._klOnsite || [];

        var sectionRoot = document.querySelector('[data-clc-root]');
        var visitorLanguage = sectionRoot
          ? sectionRoot.dataset.language
          : (document.documentElement.lang || 'en');

        var bioAgeFormId = visitorLanguage.toLowerCase().startsWith('fr')
          ? 'XuFVbt'
          : 'TtkG89';

        window._klOnsite.push([
          'openForm',
          bioAgeFormId
        ]);
      });
    });
  }

  function initializeCellularSections() {
    document.querySelectorAll('[data-clc-root]').forEach(connectCellularSection);
    connectBioAgePreorderButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCellularSections);
  } else {
    initializeCellularSections();
  }

  document.addEventListener('shopify:section:load', initializeCellularSections);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
